(function() {
    'use strict';

    module.exports = {
        getPriceNoWrap: function(price) {
            return '<span class="odf-text-nowrap">' + price + '</span>';
        },
    };
}());
